import { render, staticRenderFns } from "./IndicatorsOfScientificActivity.vue?vue&type=template&id=7d7d1b50&scoped=true"
import script from "./IndicatorsOfScientificActivity.vue?vue&type=script&lang=js"
export * from "./IndicatorsOfScientificActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7d1b50",
  null
  
)

export default component.exports